import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import CollapsibleSwitchListItem from '../../../../../../list-items/CollapsibleSwitchListItem';

const ParticlesRotationListItem = (props) => {
    const { rotationEnabled, index, updateParticleElement } = props;

    const onRotationChange = (checked) => {
        updateParticleElement(index, {
            rotationEnabled: checked
        });
    };

    return (
        <CollapsibleSwitchListItem
            text='Rotation'
            checked={rotationEnabled || false}
            onChange={onRotationChange}
            expansionEnabled={false}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const particleElement = state.createPreview.present.videoSettings.elements.particles.items[ownProps.index];

    return {
        rotationEnabled: particleElement.rotationEnabled || false
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateParticleElement = (index, properties) => dispatch(createActions.updateParticleElement(index, properties));
    return { updateParticleElement }
}

export default connect(mapStateToProps, mapDispatchToProps)(ParticlesRotationListItem);
